
    import Vue from 'vue';
    import CUPEService from '@/apps/shared/services/cupe-service';
    import MailService from '@/apps/shared/services/email-service';
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';
    import ContractFinish from "@/apps/shared/components/ContractFinish.vue";
    import { TitleAndPromotionsDetails } from '@/apps/shared/models/titleAndPromotionsDetails';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import ParamCotizService from '@/apps/shared/services/ParamCotizOfSession-service';

    interface payload {
        productId: number;
        pricingId: number;
        leadId: string;
        contratante: {
            firstName: string;
            lastName: string;
            documentNumber: string;
            address?: string;
            areaCode: string;
            telephone: string;
            email: string;
        };
        plan: {
            planDescription: string;
            premioMensual: string;
            capital: number;
        };
        DataGood: {
            goodBrand: string;
            goodModel?: string;
        };
        ProductDataSelected: {
            productDescription: string;
            planNote: string;
        };
        referente: string;
        medium: string;
        pas: string;
    }

    interface getParamCotizResponse {
        hasData: boolean;
        message: string;
        data: string | null;
    }

    export default Vue.extend({
        components: {
            ContractFinish
        },
        name: 'ElectronicDeviceFinalPayment',
        data() {
            return {
                titleAndPromotionDetails: {
                    icon: {
                        src: '/Icons/check.png',
                    },
                } as TitleAndPromotionsDetails,
                externalIdentifier: null,
                payload: null as payload | null,
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Tecnología';
                const actualPath = '/tecnologia';
                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, null, null);
                    const title = this.$store.getters.getWebSaleData?.pageCustomization?.navbar?.title ?? '';
                    this.payload.pas = title === defaultTitle ? null : title;
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultElectronicDeviceGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            getFilePath() {
                this.$router.push({ name: 'electronic-equipment-tab-One' });
            },

            fetchSessionPayload(guid: string): Promise<void> {
                return ParamCotizService.getParamCotiz(guid)
                    .then(resp => {
                        if (!resp.hasData || !resp.data) {
                            console.warn(resp.message);
                            throw new Error(resp.message);
                        }
                        this.payload = JSON.parse(resp.data) as payload;
                    });
            },

            getMailValues() {
                const p = this.payload!;

                const rawName = p.contratante.firstName
                    .toLowerCase()
                    .split(' ')[0];
                const firstName = rawName.charAt(0).toUpperCase() + rawName.slice(1);

                // Fechas
                const effectDate = new Date();
                const vigencyDate = new Date(effectDate);
                vigencyDate.setFullYear(effectDate.getFullYear() + 1);

                // Parámetros del reporte
                const parameters = [
                    { name: "@ReportCode", value: "27" },
                    { name: "@contratante", value: firstName },
                    { name: "@nombrePlan", value: p.plan.planDescription },
                    { name: "@vigenciaDesde", value: `${effectDate.getDate()}/${effectDate.getMonth() + 1}/${effectDate.getFullYear()}` },
                    { name: "@vigenciaHasta", value: `${vigencyDate.getDate()}/${vigencyDate.getMonth() + 1}/${vigencyDate.getFullYear()}` },
                    { name: "@costoMensual", value: p.plan.premioMensual },
                    { name: "@goodSelected", value: p.ProductDataSelected.productDescription },
                    { name: "@goodBrand", value: p.DataGood.goodBrand },
                    { name: "@goodModel", value: p.DataGood.goodModel || "" },
                    { name: "@labelModel", value: p.DataGood.goodModel ? "Modelo: " : "" },
                    { name: "@sumaAsegurada", value: p.plan.capital.toString() },
                    { name: "@descriptionPlanNote", value: p.ProductDataSelected.planNote }
                ];

                return JSON.stringify({
                    parameters,
                    to: p.contratante.email,
                    from: "cotizador@sancorseguros.com",
                    productId: 1000
                });
            },
            async addFinishQuotation() {
                sessionStorage.setItem("ExitOrContinueModal", "true");

                const p = this.payload!;
                const FormattedPremioMensual = p.plan.premioMensual.replaceAll('.', '');

                NF.UI.Page.block();

                var leadId = p.leadId;
                var planData = p.plan;
                var externalIdentifier = p.pricingId;
                var clientData = p.contratante.address!;
                var localidad = p.contratante.address!;
                var ramo = "Tecnologia";

                const eventData = {
                    'pas': this.payload.pas,
                    'email': this.payload.contratante.email,
                    'product': 'tecnologia',
                    'event': 'cotizador-tecnologia-venta-completa',
                    'value': FormattedPremioMensual,
                    'referente': this.payload.referente,
                    'medio': this.payload.medium
                };

                window.globalThis.dataLayer.push(eventData);

                const customWindow = window as typeof window & {
                    _qsie?: Array<typeof eventData>;
                };

                customWindow._qsie ??= [];
                customWindow._qsie.push(eventData);

                //--------------Llamada al AddFinishedQuotation (Dentro del finish())---------------------
                await CUPEService.Finish(parseInt(externalIdentifier), 1000, clientData.lastName, clientData.documentNumber, localidad, clientData.email, clientData.firstName, externalIdentifier, FormattedPremioMensual, planData.planDescription, ramo, clientData, clientData.telephone).then(async (FinishResult) => {
                    if (FinishResult) {
                        CRMCotizadorWebService.CreateOrEditLead(leadId, null, location.href, null, null, 1000, true, "8", null, null, null);
                        //ENVIO DE EMAIL
                        await MailService.sendMail(this.getMailValues()).then(response => {
                            let notificationType = response.result ? NF.Notification.Type.SUCCESS : NF.Notification.Type.ERROR;
                            let notificationTitle = response.result ? 'Mail Enviado' : 'Error';
                            let notificationContent = response.result ? 'Mail enviado exitosamente.' : 'Se produjo un error inesperado.';
                            NF.Notification.show({
                                type: notificationType,
                                title: notificationTitle,
                                content: notificationContent,
                                position: NF.Notification.Positions.TOP_RIGHT,
                                clickClose: true,
                                autoHideDelay: 10000,
                            });
                        }).finally(() => NF.UI.Page.unblock());
                    } else {
                        const eventData = {
                            'pas': this.payload.pas,
                            'email': this.payload.contratante.email,
                            'product': 'tecnologia',
                            'event': 'errorServidor',
                            'paso': 'cotizador-tecnologia-venta-completa',
                            'referente': this.payload.referente,
                            'medio': this.payload.medium
                        };

                        window.globalThis.dataLayer.push(eventData);

                        const customWindow = window as typeof window & {
                            _qsie?: Array<typeof eventData>;
                        };

                        customWindow._qsie ??= [];
                        customWindow._qsie.push(eventData);
                    }
                });
            }
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                const guid = sessionStorage.getItem('ParamId');
                if (!guid) {
                    console.error('No hay ParamId en sessionStorage');
                    return;
                }

                await this.fetchSessionPayload(guid);

                const parallelPromises = [
                    this.pageCustomization(),
                    this.updateByProductGoogleAnalytics()
                ];

                await Promise.all([
                    ...parallelPromises,
                ]);

                await this.addFinishQuotation();

            } finally {
                NF.UI.Page.unblock();
            }
        },
    });
